<template>
  <div
    v-if="isLoading"
    :class="isLoading ? 'loaderContainer' : ''">
    <div class="lds-ring"><div/><div/><div/><div/></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "./style.scss";
</style>
